module.exports = __webpack_public_path__ + "assets/img/img34.9e7f8fc2.png";